import { render } from "./payment_account.vue?vue&type=template&id=7518ddf2"
import script from "./payment_account.vue?vue&type=script&lang=js"
export * from "./payment_account.vue?vue&type=script&lang=js"

import "./payment_account.vue?vue&type=style&index=0&id=7518ddf2&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__